<template>
    <div class="lgn-container">
        <form class="lgn-form">
            <v-text-field v-model="user" label="Usuario" :disabled="loading" />
            <v-text-field
                v-model="pwd"
                label="Contraseña"
                type="password"
                @keypress.enter="onLogin"
                :disabled="loading"
            />
            <v-btn @click="onLogin">
                <clip-loader
                    v-if="loading"
                    size="16px"
                    color="black"
                ></clip-loader>
                <span v-else>Iniciar Sesión</span>
            </v-btn>
        </form>
    </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import {
    ADMIN_TYPE,
    SECRETARIA_TYPE,
    FUNCIONARIO_TYPE,
    SUBCOMISION_TYPE,
    HELPDESK_TYPE
} from '@/helpers/roleTypes';

export default {
    components: {
        ClipLoader,
    },
    data: () => {
        return {
            user: '',
            pwd: '',
            loading: false,
        };
    },
    methods: {
        onLogin() {
            this.loading = true;
            this.$store
                .dispatch('login', {
                    code: this.user,
                    password: this.pwd,
                })
                .then(res => {
                    if (res.logged) {
                        switch (res.view) {
                            case ADMIN_TYPE:
                            case SECRETARIA_TYPE:
                                this.$router.push({
                                    name: 'Admin - Contratos',
                                });
                                break;
                            case HELPDESK_TYPE:
                                this.$router.push({
                                    name: 'padron',
                                });
                                break;
                            case FUNCIONARIO_TYPE:
                            case SUBCOMISION_TYPE:
                                this.$router.push({ name: 'Mesas' });
                                break;
                            default:
                                this.$router.push({ name: 'home' });
                        }
                    } else {
                        this.loading = false;
                        // console.error(res);
                    }
                })
                .catch(err => {
                    this.$store.dispatch('errorMessage', `${err}`);
                })
                .finally(_ => this.loading = false);
        },
    },
};
</script>

<style scoped>
/* TODO: remove this later */

.lgn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 2.5rem;
}

.lgn-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 16rem;
    padding: 1rem;
}

.lgn-input {
    margin: 0.5rem 0;
    width: 100%;
    height: 2rem;
    border: solid #cccccc 1px;
    padding: 0 0.5rem;
}

.lgn-button {
    margin: 0.5rem 0;
    width: 100%;
    height: 2rem;
    background-color: #cccccc;
    border: none;
    cursor: pointer;
}
</style>
